import React from "react";

const PermissionSwitch = ({ yes, no, hasPermissions, shouldHavePermissions }) => {

  const isValidPermission = (shouldHavePermissions, hasPermissions) => {
    let isValid = false;
    shouldHavePermissions.forEach(item => {
       if (hasPermissions.includes(item)) {
         isValid = true;
       }
    });
    return isValid;
  };

  if (shouldHavePermissions && hasPermissions && !isValidPermission(shouldHavePermissions, hasPermissions)) {
    return (
      <>{no}</>
    );
  } else {
    return <>{yes}</>;
  }
};

export default PermissionSwitch;
